/**
 * Backing source for a user's private-task default plan.
 */ export var DefaultPlanSource = /*#__PURE__*/ function(DefaultPlanSource) {
    DefaultPlanSource["ToDo"] = "todo";
    DefaultPlanSource["Planner"] = "planner";
    return DefaultPlanSource;
}({});
